// extracted by mini-css-extract-plugin
module.exports = {"visual":"Development_visual__v_bis","background":"Development_background__jMN12","wrapper":"Development_wrapper__W0kRl","image":"Development_image__LAgN6"};